
export interface IScoreData {
  score: number;
  total: number;
}
export interface IStatusQtrlyData {
  status: string;
  qtrYear: string;
  total: number;
}

export interface IAssessmentSummaryData {
  totalAccounts: number;
  created: number;
  completed: number;
  inProgress: number;
  notStarted: number;
}

export class ChartQuarters {

  public quarters: Array<string> = [];

  constructor(endDate: Date, qtrs: number) {
    const arr = [];
    let qtr: number = Math.floor((endDate.getMonth() / 3)) + 1;
    let yr: number = endDate.getFullYear();

    for (let i = 0; i < qtrs; i++) {
      this.addQtrYear(qtr, yr);
      if (--qtr < 1) {
        qtr = 4;
        yr--;
      }
    }
  }
  addQtrYear(qtr: number, yr: number) {
    this.quarters.push(`Q${qtr} ${yr}`);
  }
}
